"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getSegmentUser(userId) {
    const isNotProd = window.location.hostname.indexOf('dev') >= 0 || window.location.hostname.indexOf('localhost') >= 0;
    const apiUrl = isNotProd ? 'https://api.staging.uscca.com/users/' : 'https://api.uscca.com/users/';
    if (!userId) {
        return Promise.resolve().then(function () {
            return null;
        });
    }
    const userResponse = fetch(apiUrl + userId, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(function (response) {
        if (response.ok) {
            return response.json();
        }
        else {
            return null;
        }
    })
        .then(function (user) {
        const userData = user && user.data;
        return userData;
    })
        .catch(function (err) {
        console.error(err);
        return null;
    });
    return userResponse;
}
exports.default = getSegmentUser;
